// NPM
import React, { Fragment } from "react"
import Helmet from "react-helmet";
import ReactTable from "react-table";

// App
import config from "../config";
import jobsData from '../data/jobsboard.json';

import 'react-table/react-table.css'
import '../sass/cayman-theme.scss';
import '../sass/app.scss';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  renderJobs() {
    const columns = [{
      Header: props => <h3 className="table-header">Name</h3>,
      accessor: 'name',
      Cell: props => <span style={{ textTransform: 'capitalize'}}>{props.value}</span>
    }, {
      Header: props => <h3 className="table-header">Website</h3>,
      accessor: 'website',
      Cell: props => (
        props.value ?
        <a target="_blank" rel="noopener noreferrer" href={props.value}>{props.value}</a> :
        'N/A'
      )
    }, {
      Header: props => <h3 className="table-header">Role</h3>,
      accessor: 'role',
    },]

    return (
      <ReactTable
        data={jobsData}
        columns={columns}
        defaultPageSize={50}
        defaultSorted={[
          {
            id: "name"
          }
        ]}
      />
    )
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{config.siteTitle}</title>
          <link rel="canonical" href={`${config.siteUrl}`} />
        </Helmet>

        <header className="page-header" role="banner">
          <h1 className="project-name">{ config.siteTitleShort }</h1>
          <h2 className="project-tagline">{ config.siteDescription }</h2>
          <a href={config.repository} class="btn" target="_blank" rel="noopener noreferrer">View on GitHub</a>
          <a href="https://gitumarkk.github.io/kubecon2018jobs/jobsboard.jpg" class="btn" target="_blank" rel="noopener noreferrer">View Board</a>
        </header>

        <main id="content" class="main-content" role="main">
          { this.renderJobs() }

          <footer class="site-footer">
            <span class="site-footer-owner">
              <a href="{{ site.github.repository_url }}">
                {config.siteTitle}
              </a> is maintained by <a href={config.repositoryUsernameUrl}>{config.repositoryUsername}</a>.
            </span>
            <span class="site-footer-credits">This page was generated by <a href="https://www.gatsbyjs.org/" target="_blank" rel="noopener noreferrer">Gatsby</a> and hosted on <a href="https://pages.github.com" target="_blank" rel="noopener noreferrer">GitHub Pages</a>.
            </span>
          </footer>
        </main>
      </Fragment>
    )
  }
}
export default Index
